import { clearStorage, getStorage } from "../storage";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import toastMessage from "../toastMessage";
import { getClientIP } from "../clientIp";

export const apiHandler = () => {
  const env = process.env.REACT_APP_BBMS_BASE_API;

  console.log("Base API URL:", env);

  if (!env) return;

  return env;
};

const createAxiosInstance = () => {
  const baseURL = apiHandler();
  if (!baseURL) {
    throw new Error("API baseURL not configured");
  }

  const instance = axios.create({
    baseURL,
    // timeout: 10000,
    headers: {
      "Access-Control-Allow-Origin": "*",
    },
  });

  instance.interceptors.request.use(
    async (config) => {
      // Check for internet connectivity before making the request
      if (!navigator.onLine) {
        toastMessage("Application is offline");
        return (window.location.href = "/common/offline");
      }

      const userLoggedIn = await getStorage();
      let { token, role } = userLoggedIn || {};

      if (token) {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        // Check if token is expired
        if (
          decodedToken &&
          decodedToken?.exp &&
          decodedToken?.exp < currentTime
        ) {
          try {
            clearStorage();
            window.location.href =
              role === "superAdmin" || role === "account"
                ? "/admin-login"
                : "/login";
          } catch (error) {
            console.error("Failed  token", error);
            // Redirect to login page or handle token refresh failure
            clearStorage();
            window.location.href =
              role === "superAdmin" || role === "account"
                ? "/admin-login"
                : "/login";
            return Promise.reject(new Error("Token failed"));
          }
        }

        config.headers.Authorization = `Bearer ${token}`;
      }

      const clientIp = await getClientIP();
      if (clientIp) {
        config.headers["X-Client-IP"] = clientIp;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  instance.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const userLoggedIn = await getStorage();
      let { role } = userLoggedIn || {};

      // Check if error response exists and if the status is 401
      if (error.config && error.response) {
        const { status, request } = error.response;

        const isTokenError =
          status === 401 ||
          (status === 403 &&
            ["Forbidden: Invalid Token", "Forbidden: No Token Provided", "Session expired"].some(
              (msg) => error.response?.data?.error?.includes(msg)
            ));

        if (isTokenError && !request?.responseURL?.includes("auth")) {
          console.error(
            `Auth error - ${status}. Redirecting to login. URL: ${error.config.url}`
          );

          clearStorage();

          window.location.href =
            role === "superAdmin" || role === "account"
              ? "/admin-login"
              : "/login";
        } else {
          console.error(`Error in request to URL: ${error.config.url}`, error);
        }
      } else {
        console.error("Request error", error);
      }

      return Promise.reject(error);
    }
  );

  return instance;
};

const api = createAxiosInstance();

export default api;
